<p-drawer
  [fullScreen]="isMobileView"
  [showCloseIcon]="false"
  [visible]="sideBarVisible()"
  (visibleChange)="sideBarVisible.set($event)"
  (onHide)="resetSideBar()">
  <ng-template #header>
    <div class="w-full">
      <div class="flex justify-between items-center">
        <a [routerLink]="['/apps']">
          <div class="flex items-center justify-between cursor-pointer" (click)="closeDrawer()">
            <div class="flex items-center">
              <img
                src="/assets/images/offconon.svg"
                height="50"
                class="mr-2 w-7"
                alt="{{ 'OffConOn' | translate }}" />
              <div>
                <span class="block text-sm font-bold"> OffConOn </span>
                <p class="m-0 text-xs text-primary">
                  {{ 'Apps' | translate }}
                </p>
              </div>
            </div>
          </div>
        </a>
        <p-button icon="pi pi-times" [link]="true" (click)="resetSideBar()" />
      </div>
      <div class="mt-3">
        <p-iconfield iconPosition="left">
          <p-inputicon styleClass="pi pi-search" />
          <input
            #searchInput
            class="w-full"
            autofocus
            type="text"
            pInputText
            placeholder="{{ 'Search' | translate }}"
            (input)="onSearchChange($event.target)" />
        </p-iconfield>
      </div>
    </div>
  </ng-template>

  @for (mainItem of filteredNavData; track $index) {
    @if (mainItem?.visible) {
      <div class="font-extrabold text-xs uppercase mb-1 mt-4 hide-left-small">
        {{ mainItem.name }}
      </div>
    }
    @for (item of mainItem.elements; track $index) {
      @if (item?.visible !== false) {
        <a
          class="flex items-center py-1 cursor-pointer gap-2"
          [routerLink]="item.link"
          (click)="closeDrawer()">
          <span class="inline-flex items-center justify-center text-blue-500">
            <mat-icon fontIcon="{{ item.icon ? item.icon : 'add_circle' }}" />
          </span>
          <span class="inline-flex flex-col gap-2 opacity-60 hide-menu-small">
            <span class="text-sm">{{ item.firstLine }}</span>
          </span>
        </a>
      }
    }
  }
</p-drawer>
